import * as React from "react";
import { Button } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Row } from "react-bootstrap";
import { ExclamationCircle } from "react-bootstrap-icons";
export default function DataPullSavePopUp(props) {
  return (
    <div>
      <Dialog open={props.open} onClose={() => props.handleClose()} aria-labelledby="alert-dialog-title">
        <DialogTitle id="alert-dialog-title" style={{ color: "#2C345B", fontFamily: "visby-bold", fontSize: "24px" }}>
          <ExclamationCircle style={{ verticalAlign: "text-top" }} /> &nbsp; Important: Initiating Data Pull
        </DialogTitle>
        <div onClick={() => setOpen(false)} style={{ position: "absolute", right: "5px", cursor: "pointer" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style={{ position: "relative" }}>
            <path
              fill="rgb(0,0,0)"
              fillRule="evenodd"
              d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
            />
          </svg>
        </div>
        <DialogContent>
          <p style={{ color: "#555555", fontFamily: "nunito-regular", fontSize: "14px" }}>
            You have requested to initiate a data pull, or changes made on this page would require a data pull to proceed.
          </p>
          <p style={{ color: "#2C345B", fontFamily: "nunito-bold", fontSize: "14px" }}>
            A data pull can take up to several hours and you will not be able to access or make changes to this account's associated configuration pages until
            the pull is finished. Please proceed with full certainty!
          </p>
        </DialogContent>
        <div className="d-flex flex-column flex-md-row justify-content-between p-4">
          <Button
            onClick={() => props.handleClose()}
            style={{
              backgroundColor: "#3291c1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}>
            Hold on, go back
          </Button>
          <Button
            onClick={() => {
              props.manualDataPull();
              if (props.onboarding == true) {
                setTimeout(() => props.submitForm(props.nextPage), 1000);
              }
              else {
                props.submitForm();
              }
            }}
            style={{
              backgroundColor: "#42ba96",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}
            autoFocus>
            Save changes and initiate data pull
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
